const $priceSelector = $('.product__price span');
const $productSelect = $('#product-select');
const $addToCartButton = $('.form__btn--submit');

$('.product-single__variant select').on('change', function() {
  const $this = $(this);
  const $selectedOptions = $this
    .closest('.product-single__variants')
    .find('option:selected');
  let selector = '';

  $selectedOptions.each(function() {
    const $option = $(this);
    const optionName = $option
      .closest('.product-single__variant')
      .data('option');

    selector += `[data-${optionName}="${$option.val()}"]`;
  });

  if ($productSelect.find(`option${selector}`).length) {
    $productSelect
      .find(`option${selector}`)
      .prop('selected', true)
      .trigger('change');
  } else {
    $addToCartButton
      .prop('disabled', true)
      .val(Shopify.theme.locale.products.product.unavailable);
  }
});

$productSelect.on('change', function() {
  const $this = $(this);
  const $option = $this.find('option:selected');

  if ($option.data('compared_price')) {
    $priceSelector.html(
      `<strike>${$option.data('compared_price')}</strike><span>${$option.data(
        'price'
      )}</span>`
    );
  } else {
    $priceSelector.html(`<span>${$option.data('price')}</span>`);
  }

  if ($option.prop('disabled')) {
    $addToCartButton
      .attr('disabled', true)
      .val(Shopify.theme.locale.products.product.sold_out)
      .addClass('disabled')
  } else {
    $addToCartButton
      .attr('disabled', false)
      .val(Shopify.theme.locale.products.product.add_to_cart)
      .removeClass('disabled')
  }
});
